import { fetchProfile } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import { BadgeCheck } from "lucide-react";
import SkillsCard from "./SkillsCard";

const Skills = () => {
  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: fetchProfile,
  });
  return (
    <div id="skills" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-2 text-teal">
          Skills & Expertise
        </h2>
        <p className="text-gray-400 mb-6 max-w-2xl">
          Here's a brief overview of my technical expertise.
        </p>
      </div>
      <SkillsCard skills={profile?.skills} maxCount={8} />
    </div>
  );
};

export default Skills;
